import classNames from 'classnames';

import { Skeleton } from '../skeleton';
import Typography, { TypographyProps } from '../typography/typography';

export interface DDProps extends TypographyProps {
  className?: string;
  emptyValue?: React.ReactNode;
  isEmpty?: boolean;
  loading?: boolean;
}

/**
 * Description details element (dd) provided as a component enhanced with more options based on the Typography component
 */
export function DD({
  children,
  className,
  emptyValue = '-',
  isEmpty = false,
  loading = false,
  ...TypographyProps
}: React.PropsWithChildren<DDProps>) {
  return (
    <Typography
      variant="dd"
      variantComponent="dd"
      {...TypographyProps}
      className={classNames('overflow-hidden text-ellipsis', className)}
    >
      {loading && <Skeleton variant="text" />}

      {!loading && (isEmpty ? emptyValue : children)}
    </Typography>
  );
}

export default DD;
